export const calculateDiscountedPrice = (price, discount) => {
    return (parseFloat(price) - parseFloat(price) * (discount / 100)).toFixed(2);
};

// Usage
// const discountedPrice = calculateDiscountedPrice(pkg?.price, pkg?.package_discount);
// console.log(discountedPrice);
